/*eslint-disable*/
import React, {useState, useEffect} from "react";
import { makeStyles } from "@mui/styles";
import List from "@mui/material/List";
import ListItem from "@mui/material/ListItem";
import { Info, AccountBox, House } from "@mui/icons-material";
import Button from "components/CustomButtons/Button.js";
import styles from '../../styles/headerLinksStyle.js';
import { useSelector } from "react-redux";
import { useNavigate, useLocation } from 'react-router-dom';
import { useTranslation } from "react-i18next";
import EmailIcon from '@mui/icons-material/Email';
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import {Typography} from "@mui/material";
import moment from 'moment/min/moment-with-locales';
import { withFallbackTranslations } from 'common/src/other/fallbackTranslations';

const useStyles = makeStyles(styles);

export default function HeaderLinks(props) {
  const classes = useStyles();
  const mobile = !!props.mobile;
  const light = !mobile && !!props.light;
  const location = useLocation();
  const path = location.pathname || '/';
  const isHome = path === '/' || path === '';
  const isAccount = path.startsWith('/login') || path.startsWith('/bookings') || path.startsWith('/dashboard');
  const isAbout = path.startsWith('/about-us');
  const isContact = path.startsWith('/contact-us');
  const auth = useSelector(state => state.auth);
  const settings = useSelector(state => state.settingsdata.settings);
  const languagedata = useSelector(state => state.languagedata);
  const { i18n,t } = useTranslation();
  const [loggedIn, setLoggedIn] = useState(false);
  const navigate = useNavigate();

  const [langSelection, setLangSelection] = useState();
  const [multiLanguage,setMultiLanguage] = useState();

  const handleLanguageSelect = (event) => {
    i18n.addResourceBundle(multiLanguage[event].langLocale, 'translations', withFallbackTranslations(multiLanguage[event].langLocale, multiLanguage[event].keyValuePairs));
    i18n.changeLanguage(multiLanguage[event].langLocale);
    setLangSelection(event);
    moment.locale(multiLanguage[event].dateLocale);
    setIsActive(false);
  };

  useEffect(()=>{
    if(languagedata.langlist){
      for (const key of Object.keys(languagedata.langlist)) {
        if(languagedata.langlist[key].langLocale === i18n.language){
          setLangSelection(key);
        }
      }
      setMultiLanguage(languagedata.langlist);
    }
    
  },[languagedata.langlist]);

  useEffect(()=>{
    if(auth.profile && auth.profile.uid){
      setLoggedIn(true);
    }else{
      setLoggedIn(false);
    }
  },[auth.profile]);
  
  const [isActive, setIsActive] = useState(false);

  const toggleDropdown = () => {
    setIsActive(!isActive);
  };

  const navClass = (active) => {
    if (mobile) {
      return active
        ? `${classes.navLinkActiveHome} ${classes.navLinkMobile} ${classes.navLinkMobileActive}`
        : `${classes.navLinkModern} ${classes.navLinkMobile}`;
    }
    if (active) {
      return light
        ? `${classes.navLinkActiveHome} ${classes.navLinkActiveHomeLight}`
        : classes.navLinkActiveHome;
    }
    return light
      ? `${classes.navLinkModern} ${classes.navLinkModernLight}`
      : classes.navLinkModern;
  };
  const go = (to) => {
    navigate(to);
    if (props.onNavigate) props.onNavigate();
  };
  const socialClass = mobile
    ? `${classes.socialBtn} ${classes.socialBtnMobile}`
    : light ? `${classes.socialBtn} ${classes.socialBtnLight}` : classes.socialBtn;
  const facebookBtn = (
    <Button
      color="transparent"
      href={(settings && settings.FacebookHandle) ? settings.FacebookHandle : "https://facebook.com"}
      target="_blank"
      className={socialClass}
    >
      <i className="fab fa-facebook" style={{ fontSize: '17px' }} />
    </Button>
  );
  const instagramBtn = (
    <Button
      color="transparent"
      href={(settings && settings.InstagramHandle) ? settings.InstagramHandle : "https://instagram.com"}
      target="_blank"
      className={socialClass}
    >
      <i className="fab fa-instagram" style={{ fontSize: '17px' }} />
    </Button>
  );
  const labelSx = { fontFamily: "'Outfit', 'Poppins', sans-serif", fontSize: '12px', fontWeight: 500, textTransform: 'uppercase', letterSpacing: '0.6px' };
  const ink = light ? '#1A0F3B' : '#FFFFFF';

  return (
    <List className={mobile ? `${classes.list} ${classes.listMobile}` : classes.list}>
      <ListItem className={classes.listItem}>
        <Button
          color="transparent"
          className={navClass(isHome)}
          onClick={(e) => { e.preventDefault(); go('/') }}
        >
          <House className={classes.icons} />
          <Typography sx={labelSx} style={{ fontWeight: isHome ? 700 : 500 }}>
            {t('home') || 'INICIO'}
          </Typography> 
        </Button>
      </ListItem>
      <ListItem className={classes.listItem}>
        <Button
          color="transparent"
          className={navClass(isAccount)}
          onClick={(e) => { e.preventDefault(); 
            if(loggedIn){
              go('/bookings')
            } else{
              go('/login')
            }
          }}
        >
          <AccountBox className={classes.icons} />  
          <Typography sx={labelSx} style={{ fontWeight: isAccount ? 700 : 500 }}>
            {loggedIn ? (t('myaccount') || 'MI CUENTA') : 'MI CUENTA'}
          </Typography>
        </Button>
      </ListItem>
      <ListItem className={classes.listItem}>
        <Button
          color="transparent"
          className={navClass(isAbout)}
          onClick={(e) => { e.preventDefault(); go('/about-us') }}
        >
          <Info className={classes.icons} />
          <Typography sx={labelSx} style={{ fontWeight: isAbout ? 700 : 500 }}>
            {t('about_us') || 'SOBRE NOSOTROS'}
          </Typography>
        </Button>
      </ListItem>
      <ListItem className={classes.listItem}>
        <Button
          color="transparent"
          className={navClass(isContact)}
          onClick={(e) => { e.preventDefault(); go('/contact-us') }}
        >
          <EmailIcon className={classes.icons} />
          <Typography sx={labelSx} style={{ fontWeight: isContact ? 700 : 500 }}>
            {t('contact_us') || 'CONTÁCTANOS'}
          </Typography>
        </Button>
      </ListItem>

      {mobile ? (
        <ListItem className={`${classes.listItem} ${classes.socialRowMobile}`}>
          {facebookBtn}
          {instagramBtn}
        </ListItem>
      ) : (
        <>
          <ListItem className={`${classes.listItem} ${classes.socialItem}`}>{facebookBtn}</ListItem>
          <ListItem className={classes.listItem}>{instagramBtn}</ListItem>
        </>
      )}

      <ListItem className={`${classes.listItem} ${mobile ? classes.langItemMobile : classes.langItem}`}>
        <div style={{ display: "flex", justifyContent: "center", alignItems: "center", height: "100%" }}>
          <div style={{ position: "relative" }}>
            <div
              className={light ? `${classes.toggleDropdown} ${classes.toggleDropdownLight}` : classes.toggleDropdown}
              onClick={toggleDropdown}
            >
              <span
                style={{
                  fontSize: '13px',
                  color: ink,
                  fontFamily: "'Outfit', 'Poppins', sans-serif",
                  fontWeight: 500,
                }}
              >
                {multiLanguage && multiLanguage[langSelection] ? multiLanguage[langSelection].langName : 'Español'}
              </span>
              <ArrowDropDownIcon
                style={{
                  fontSize: '18px',
                  transition: 'transform 0.3s ease',
                  transform: isActive ? 'rotate(-180deg)' : 'rotate(0)',
                  color: light ? '#6411ED' : '#FFFFFF',
                  marginLeft: '4px',
                }}
              />
            </div>

            {isActive && (
              <ul
                className={light ? `${classes.optionUl} ${classes.optionUlLight}` : classes.optionUl}
                style={mobile ? { left: 0, right: 'auto' } : undefined}
              >
                {multiLanguage && Object.keys(multiLanguage).length > 0 ? (
                  Object.keys(multiLanguage).map((key, index) => (
                    <li
                      className={light ? `${classes.option} ${classes.optionLight}` : classes.option}
                      key={key}
                      onClick={() => handleLanguageSelect(index)}
                    >
                      <span>{multiLanguage[key].langName}</span>
                    </li>
                  ))
                ) : (
                  <li
                    className={light ? `${classes.option} ${classes.optionLight}` : classes.option}
                    onClick={() => setIsActive(false)}
                  >
                    <span>Español</span>
                  </li>
                )}
              </ul>
            )}
          </div>
        </div>
      </ListItem>
    </List>
  );
}
